<template>
	<div id="packs-page">

		<!-- <section class="banner-section">
			<div class="container oversized-container">
				<div class="row align-items-center">
					<div class="col-12 col-title">
						<h5>Dispositivos compatibles con la red compartida<br />(banda 28*)</h5>
						<h6>*Banda del espectro de 700 MHz para México.</h6>
					</div>
				</div>
			</div>
		</section> -->

		<section class="container oversized-container my-2 content-section">
			<div class="row">
				<div class="col-12 col-title-s1">
					<h3 class="title">Paquete MiFi</h3>

					<open-pay-charge ref="openPayModal" />

					<p>
						Selecciona alguno de nuestros paquetes Skycel para tu modem MiFi.
					</p>

				</div>

				<offers-slider class="col-12 col-carousel"  oferta-tipo="planMifi"/>

			</div>
		</section>
	</div>
</template>

<script>
	import OffersSlider from '../daniel/offers-slider.vue';
	export default {
		components: {OffersSlider}
	};
</script>